export * from '@thalesrc/js-utils/function/call';
export * from '@thalesrc/js-utils/function/debounce';
export * from '@thalesrc/js-utils/function/defer';
export * from '@thalesrc/js-utils/function/of';
export * from '@thalesrc/js-utils/function/noop';
